declare function escape(s: string): string;

module AppKitchen {
    export module LoginManager {

        var loginEnsured = false;
        var intervalId = -1;

        function getParameterFromQueryString(key: string, queryString: string): string {
            var queries = queryString.split("&");
            for (var i = 0; i < queries.length; i++) {
                if (queries[i].indexOf(key) === 0 && queries[i][key.length] === "=") {
                    return queries[i].substr(key.length + 1);
                }
            }
            return undefined;
        }

        function redirectToOAuth(logout: boolean): void {
            var tokenUrl = getOAuthUrl(logout);
            Cookies.remove(AppKitchen.GlobalSettings.sessionTokenCookieName);
            Cookies.remove(AppKitchen.GlobalSettings.currentUserCookieName);
            AppKitchen.BrowserHelper.setUrl(tokenUrl, {refresh: true, push: false});
        }

        function getOAuthUrl(logout: boolean) {
            var tokenserviceUrl = AppKitchen.GlobalSettings.securityTokenServiceOAuthUrl;
            var welcomeMessage = AppKitchen.GlobalSettings.welcomeMessage;
            var loginTheme = AppKitchen.GlobalSettings.loginTheme;
            var tokenUrl = tokenserviceUrl + "?returnurl=" + encodeURIComponent(document.location.href) + (loginTheme ? "&theme=" + loginTheme : "") + (logout ? "&donotlogin=true" : "") + (welcomeMessage ? "&message="+welcomeMessage : "");
            return tokenUrl;
        }

        function ensureLoginAndStart(start: () => void) {
            var claim = AppKitchen.BrowserHelper.UrlQuery.getParameter("claim");
            if (claim) {
                var claimString = window.atob(claim);
                var sessionToken = getParameterFromQueryString("token", claimString);
                var username = decodeURIComponent(escape(getParameterFromQueryString("username", claimString)));
                if (sessionToken && username) {
                    Cookies.set(AppKitchen.GlobalSettings.sessionTokenCookieName, sessionToken);
                    Cookies.set(AppKitchen.GlobalSettings.currentUserCookieName, username);
                }

                // remove claim from url and redirect
                AppKitchen.BrowserHelper.UrlQuery.removeParameter("claim", { refresh: true, push: false });
            } else {

                if (!AppKitchen.Data.getToken()) {
                    redirectToOAuth(false);
                    return;
                }

                AppKitchen.Data.ping(AppKitchen.GlobalSettings.pingTimeout * 1000, (result) => {
                    if (result) {
                        intervalId = window.setInterval(() => AppKitchen.Data.ping(AppKitchen.GlobalSettings.pingTimeout * 1000,() => {},() => { redirectToOAuth(false); }),AppKitchen.GlobalSettings.pingInterval * 1000);
                        loginEnsured = true;
                        start();
                    } else {
                        redirectToOAuth(false);
                    }
                }, () => {
                    AppKitchen.UIHelper.renderTemplateTo($("body")[0],AppKitchen.Templates.OAuthLink,{ href: getOAuthUrl(false) });
                    //redirectToOAuth(false);
                });

            }
        }

        export function ensureLogin(start: () => void) {
            if (loginEnsured) {
                start();
            } else {
                ensureLoginAndStart(start);
            }
        }

        export function logout(redirect: boolean) {
            // clear cookies
            Cookies.remove(AppKitchen.GlobalSettings.sessionTokenCookieName);
            Cookies.remove(AppKitchen.GlobalSettings.currentUserCookieName);

            // stop interval checker
            if (intervalId !== -1) {
                window.clearInterval(intervalId);
            }

            loginEnsured = false;

            if (redirect) {
                redirectToOAuth(true);
            }
        }

        export function getCurrentUser(): string {
            if (loginEnsured) {
                var user = Cookies.get(AppKitchen.GlobalSettings.currentUserCookieName);
                if (user) {
                    return user;
                }
            }
            return "-";
        }
    }
}